import { defineStore } from 'pinia';
import state from './state';
import actions from './actions';
import getters from './getters';

const useLanguageStore = defineStore('features', {
  state: () => ({ ...state }),
  actions,
  getters,
});

export default useLanguageStore;
